<vpfa-vehicle-or-offer-not-found>
  <div>{{ 'stock.radarUnavailable' | translate }}</div>
  <button class="see-other" nz-button nzType="link" (click)="goToDetails()">
    {{ 'stock.goToStockDetails' | translate }}
  </button>
</vpfa-vehicle-or-offer-not-found>
